/*
* This file can be replaced during build by using the `fileReplacements` array.
* `ng build` replaces `environment.ts` with `environment.prod.ts`.
* The list of file replacements can be found in `angular.json`.
* For easier debugging in development mode, you can import the following file
* to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
* This import should be commented out in production mode because it will have a negative impact
* performance if an error is thrown.
* import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
* You can find more information about Angular CLI file replacements here:
* https://angular.io/guide/build#configuring-targets
* For more information on environment variables, see:
* https://angular.io/guide/build#configuring-targets
*/

export const environment = {
    production: true,
    environment: "prod",
    apiUrl: "/api/",
    enableRemoteThemeFetch: false,
    companyCheck: "default",
    cutOffDate: "31/08/2026",
    payFastScriptUrl: "https://payfast.co.za/onsite/engine.js",
    GOOGLE_MAPS_API_KEY: '',
    diagnosticsMock: {
      enabled: false,
      fixturePath: "utilitiesdemo/utilities/device_diagnostics/meter-locations.mock.json"
    },
    firebaseConfig: {
      apiKey: "",
      authDomain: "",
      projectId: "",
      storageBucket: "",
      messagingSenderId: "",
      appId: "",
    },
    firebaseTenantId: "",
    GoogleLoginProvider: "",
    FacebookLoginProvider: "",
    recaptchaSiteKey: ""
  };
